// ============================================================
// ByOurConsent.com -- Shipping Policy Page
// /shipping
// ============================================================

import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Nav    from '../components/Nav';
import Footer from '../components/Footer';

const Section = ({ title, children }) => (
    <div style={{ marginBottom: '2rem' }}>
        <div style={{ fontSize: '11px', fontFamily: 'sans-serif', letterSpacing: '0.14em', textTransform: 'uppercase', color: '#8b6a3a', marginBottom: '8px' }}>
            {title}
        </div>
        <div style={{ fontSize: '14px', fontFamily: 'sans-serif', color: '#4a5060', lineHeight: 1.75 }}>
            {children}
        </div>
    </div>
);

const ShippingPage = () => {
    return (
        <>
            <Helmet>
                <title>Shipping Policy — By Our Consent</title>
            </Helmet>

            <Nav />

            <div style={{ background: '#1e2a3a', borderBottom: '2px solid #8b1a1a', padding: '2rem 1.5rem' }}>
                <div style={{ maxWidth: '660px', margin: '0 auto' }}>
                    <h1 style={{ fontSize: '34px', fontWeight: 600, color: '#e8dfc8', fontFamily: "'EB Garamond', Georgia, serif" }}>
                        Shipping policy
                    </h1>
                    <p style={{ fontSize: '14px', fontFamily: 'sans-serif', color: '#8a9aaa', marginTop: '8px' }}>
                        All orders are fulfilled and shipped by Printful, our print-on-demand partner.
                    </p>
                </div>
            </div>

            <div style={{ maxWidth: '660px', margin: '0 auto', padding: '2.5rem 1.5rem' }}>

                <Section title="Production time">
                    All items are printed to order. Please allow <strong>2–5 business days</strong> for your
                    order to be produced before it ships. Production times may be longer during
                    peak periods such as holidays.
                </Section>

                <Section title="Shipping times">
                    <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '1rem' }}>
                        <thead>
                            <tr style={{ background: '#ede8dc' }}>
                                <th style={{ padding: '8px 12px', textAlign: 'left', fontSize: '12px', fontFamily: 'sans-serif', color: '#1e2a3a', border: '0.5px solid #c8beaa' }}>Method</th>
                                <th style={{ padding: '8px 12px', textAlign: 'left', fontSize: '12px', fontFamily: 'sans-serif', color: '#1e2a3a', border: '0.5px solid #c8beaa' }}>Estimated delivery</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[
                                ['Standard (US)', '3–8 business days after production'],
                                ['Express (US)',  '1–3 business days after production'],
                                ['International','7–21 business days after production']
                            ].map(([method, time], i) => (
                                <tr key={method} style={{ background: i % 2 === 0 ? '#f5f0e8' : '#ede8dc' }}>
                                    <td style={{ padding: '8px 12px', fontSize: '13px', fontFamily: 'sans-serif', color: '#1e2a3a', border: '0.5px solid #c8beaa' }}>{method}</td>
                                    <td style={{ padding: '8px 12px', fontSize: '13px', fontFamily: 'sans-serif', color: '#4a5060', border: '0.5px solid #c8beaa' }}>{time}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    Shipping costs are calculated at checkout based on your location and the items in your order.
                </Section>

                <Section title="Where we ship">
                    We ship to the United States and most international destinations.
                    Orders are fulfilled from Printful's nearest production facility to your location,
                    which may be in the US, Europe, or other regions.
                </Section>

                <Section title="Tracking">
                    You will receive a tracking number by email once your order ships.
                    Use it to track your package on the carrier's website.
                    If you don't receive a tracking email within 7 business days of ordering,
                    please contact us at{' '}
                    <a href="mailto:support@byourconsent.com" style={{ color: '#8b1a1a' }}>
                        support@byourconsent.com
                    </a>.
                </Section>

                <Section title="Shipping costs">
                    Shipping costs are calculated at checkout based on your delivery address,
                    selected shipping method, and the weight/size of your order.
                    You will see the exact shipping cost before completing your purchase.
                </Section>

                <Section title="Delays">
                    Delivery times are estimates and not guaranteed. Delays may occur due to
                    carrier issues, customs processing for international orders, or peak demand
                    periods. By Our Consent is not responsible for carrier delays.
                </Section>

                <div style={{ padding: '1rem', background: '#ede8dc', border: '0.5px solid #c8beaa', borderRadius: '4px', fontSize: '13px', fontFamily: 'sans-serif', color: '#6a7080', lineHeight: 1.6 }}>
                    Questions about your shipment?{' '}
                    <Link to="/contact" style={{ color: '#8b1a1a' }}>Contact us</Link>
                    {' '}with your order number and we'll look into it.
                </div>
            </div>

            <Footer />
        </>
    );
};

export default ShippingPage;
